import styled from 'react-emotion'
import { Container as StylistContainer, spacer } from 'stylist'

const Container = styled(StylistContainer)`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  grid-gap: ${spacer(4)};
`

export default Container



// WEBPACK FOOTER //
// ./src/components/Container.js